<div class="content">
  @if ((products?.length || 0) > 0) {
    <div class="productsWrapper">
      @for (product of products; track product) {
        <button matButton="text" class="productButton" (click)="save(product)">
          <span>
            @if (product.sureFlowModel) {
              <div class="sureflowLogoContainer">
                <img class="sureflowLogo" src="assets/SFLogo.png"/>
              </div>
            }
            <img class="productImage" [src]="product.imageFileName"/>
            <div class="descriptionLabel">
              {{ product.productId }}
            </div>
          </span>
        </button>
      }
    </div>
  }
</div>
<div class="buttonRow">
  <span class="spacer"></span>
  <button class="warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
</div>
